export default __webpack_public_path__ + "static/subscribe-symbol-3abd2ce0dabf50a62fc1ead37b15ff3a.png";